export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
  pageCount: number;
}

export interface ComicData {
  id: string;
  title: string;
  author: string;
  cover: string;
  description: string;
  category: string;
  categorySlug: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  followers: number;
  tags: string[];
  updatedAt: string;
  chapters: ComicChapter[];
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '热血', slug: 'rexue' },
  { name: '恋爱', slug: 'lianai' },
  { name: '玄幻', slug: 'xuanhuan' },
  { name: '搞笑', slug: 'gaoxiao' },
  { name: '悬疑', slug: 'xuanyi' },
  { name: '科幻', slug: 'kehuan' },
  { name: '都市', slug: 'dushi' },
  { name: '冒险', slug: 'maoxian' },
  { name: '武侠', slug: 'wuxia' },
  { name: '恐怖', slug: 'kongbu' },
  { name: '治愈', slug: 'zhiyu' },
];

export const comics: ComicData[] = [
  {
    id: '1',
    title: '斗破苍穹',
    author: '天蚕土豆',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manhua%20cover%20with%20young%20warrior%20holding%20a%20flaming%20sword%20against%20dark%20stormy%20sky%2C%20epic%20fantasy%20illustration%20style%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20red%20tones%2C%20detailed%20character%20design%2C%20action%20pose&width=400&height=540&seq=comic-doupo&orientation=portrait',
    description: '天才少年萧炎在创造了家族空前绝后的修炼纪录后，突然成为了废人，种种打击接踵而至。就在他即将绝望的时候，一缕灵魂从他手上的戒指里浮现，一扇全新的大门在面前开启！这里是属于斗气的世界，没有花俏艳丽的魔法，有的，仅仅是繁衍到巅峰的斗气！',
    category: '玄幻',
    categorySlug: 'xuanhuan',
    status: '连载中',
    rating: 9.6,
    views: 12580000,
    followers: 3580000,
    tags: ['玄幻', '热血', '战斗', '逆袭'],
    updatedAt: '2026-08-03',
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'c1-1', title: '第1话 废柴少爷', number: 1, updatedAt: '2026-01-15', pageCount: 45 },
      { id: 'c1-2', title: '第2话 戒指里的灵魂', number: 2, updatedAt: '2026-01-22', pageCount: 42 },
      { id: 'c1-3', title: '第3话 焚诀初现', number: 3, updatedAt: '2026-01-29', pageCount: 48 },
      { id: 'c1-4', title: '第4话 炼药大会', number: 4, updatedAt: '2026-02-05', pageCount: 50 },
      { id: 'c1-5', title: '第5话 云岚宗之战', number: 5, updatedAt: '2026-02-12', pageCount: 55 },
      { id: 'c1-6', title: '第6话 迦南学院', number: 6, updatedAt: '2026-02-19', pageCount: 43 },
      { id: 'c1-7', title: '第7话 内院选拔', number: 7, updatedAt: '2026-02-26', pageCount: 47 },
      { id: 'c1-8', title: '第8话 陨落心炎', number: 8, updatedAt: '2026-03-05', pageCount: 52 },
      { id: 'c1-9', title: '第9话 黑角域', number: 9, updatedAt: '2026-03-12', pageCount: 44 },
      { id: 'c1-10', title: '第10话 中州风云', number: 10, updatedAt: '2026-03-19', pageCount: 50 },
    ],
  },
  {
    id: '2',
    title: '一人之下',
    author: '米二',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20supernatural%20manhua%20cover%20featuring%20a%20young%20man%20with%20mysterious%20energy%20powers%2C%20urban%20fantasy%20setting%20with%20traditional%20Taoist%20symbols%2C%20dynamic%20composition%2C%20green%20and%20gold%20accents%2C%20detailed%20illustration&width=400&height=540&seq=comic-yiren&orientation=portrait',
    description: '随着父亲失踪，神秘少女冯宝宝的造访，少年张楚岚的平静校园生活被彻底颠覆。一群拥有特异功能的异人聚集在他身边，一个关乎命运的秘密正在浮出水面。',
    category: '热血',
    categorySlug: 'rexue',
    status: '连载中',
    rating: 9.7,
    views: 18900000,
    followers: 4200000,
    tags: ['热血', '异能', '都市', '道教'],
    updatedAt: '2026-08-02',
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'c2-1', title: '第1话 异人', number: 1, updatedAt: '2026-02-01', pageCount: 38 },
      { id: 'c2-2', title: '第2话 冯宝宝', number: 2, updatedAt: '2026-02-08', pageCount: 40 },
      { id: 'c2-3', title: '第3话 罗天大醮', number: 3, updatedAt: '2026-02-15', pageCount: 46 },
      { id: 'c2-4', title: '第4话 八奇技', number: 4, updatedAt: '2026-02-22', pageCount: 42 },
      { id: 'c2-5', title: '第5话 全性攻山', number: 5, updatedAt: '2026-03-01', pageCount: 50 },
      { id: 'c2-6', title: '第6话 王也道长', number: 6, updatedAt: '2026-03-08', pageCount: 44 },
      { id: 'c2-7', title: '第7话 风后奇门', number: 7, updatedAt: '2026-03-15', pageCount: 48 },
      { id: 'c2-8', title: '第8话 碧游村', number: 8, updatedAt: '2026-03-22', pageCount: 52 },
    ],
  },
  {
    id: '3',
    title: '狐妖小红娘',
    author: '小新',
    cover: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20romance%20manhua%20cover%20with%20fox%20spirit%20girl%20in%20traditional%20red%20hanfu%20dress%2C%20cherry%20blossom%20petals%20falling%2C%20soft%20pink%20and%20warm%20tones%2C%20dreamy%20atmosphere%2C%20elegant%20character%20design%2C%20fantasy%20romance&width=400&height=540&seq=comic-huyao&orientation=portrait',
    description: '世上有人有妖，妖会与人相恋，妖寿命千万年，人的寿命有限。人死了，妖活着。人会投胎转世，但投胎以后不记得上辈子的爱。妖如果痴情的话，就去找狐妖"购买"一项服务，让投胎转世的人回忆起前世的爱。',
    category: '恋爱',
    categorySlug: 'lianai',
    status: '已完结',
    rating: 9.5,
    views: 15600000,
    followers: 3850000,
    tags: ['恋爱', '奇幻', '古风', '转世'],
    updatedAt: '2026-07-28',
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'c3-1', title: '第1话 狐妖', number: 1, updatedAt: '2026-01-10', pageCount: 35 },
      { id: 'c3-2', title: '第2话 红线仙', number: 2, updatedAt: '2026-01-17', pageCount: 38 },
      { id: 'c3-3', title: '第3话 续缘', number: 3, updatedAt: '2026-01-24', pageCount: 42 },
      { id: 'c3-4', title: '第4话 涂山', number: 4, updatedAt: '2026-01-31', pageCount: 40 },
      { id: 'c3-5', title: '第5话 月红篇', number: 5, updatedAt: '2026-02-07', pageCount: 46 },
      { id: 'c3-6', title: '第6话 王权篇', number: 6, updatedAt: '2026-02-14', pageCount: 44 },
      { id: 'c3-7', title: '第7话 南国篇', number: 7, updatedAt: '2026-02-21', pageCount: 42 },
      { id: 'c3-8', title: '第8话 竹业篇', number: 8, updatedAt: '2026-02-28', pageCount: 48 },
      { id: 'c3-9', title: '第9话 尾声', number: 9, updatedAt: '2026-03-07', pageCount: 50 },
    ],
  },
  {
    id: '4',
    title: '镇魂街',
    author: '许辰',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20action%20manhua%20cover%20with%20armored%20warrior%20summoning%20guardian%20spirit%20in%20gothic%20city%20setting%2C%20mysterious%20atmosphere%2C%20blue%20and%20black%20color%20scheme%2C%20supernatural%20guardian%20spirit%20design%2C%20dynamic%20battle%20pose&width=400&height=540&seq=comic-zhenhun&orientation=portrait',
    description: '普通的应届大学毕业生夏铃在求职之际，收到了一条奇怪的面试通知，误入罗刹街并遭到了恶灵的攻击。危难之际，曹焱兵兄弟及时出现将她解救。自此，一个普通人进入了镇魂将的世界。',
    category: '热血',
    categorySlug: 'rexue',
    status: '连载中',
    rating: 9.4,
    views: 11200000,
    followers: 2980000,
    tags: ['热血', '战斗', '守护灵', '奇幻'],
    updatedAt: '2026-08-01',
    isHot: true,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'c4-1', title: '第1话 罗刹街', number: 1, updatedAt: '2026-03-01', pageCount: 40 },
      { id: 'c4-2', title: '第2话 镇魂将', number: 2, updatedAt: '2026-03-08', pageCount: 38 },
      { id: 'c4-3', title: '第3话 守护灵', number: 3, updatedAt: '2026-03-15', pageCount: 44 },
      { id: 'c4-4', title: '第4话 于禁', number: 4, updatedAt: '2026-03-22', pageCount: 46 },
      { id: 'c4-5', title: '第5话 许褚', number: 5, updatedAt: '2026-03-29', pageCount: 42 },
      { id: 'c4-6', title: '第6话 典韦', number: 6, updatedAt: '2026-04-05', pageCount: 48 },
    ],
  },
  {
    id: '5',
    title: '非人哉',
    author: '一汪空气',
    cover: 'https://readdy.ai/api/search-image?query=Cute%20Chinese%20slice%20of%20life%20manhua%20cover%20with%20mythological%20creatures%20in%20modern%20office%20setting%2C%20nine-tailed%20fox%20girl%20in%20business%20suit%2C%20colorful%20and%20playful%20style%2C%20bright%20pastel%20colors%2C%20humorous%20illustration&width=400&height=540&seq=comic-feiren&orientation=portrait',
    description: '传说中的神仙妖怪们，在现代社会中过着爆笑又温馨的日常生活。九尾狐九月、龙女敖烈、哪吒、哮天犬……这些耳熟能详的神话人物，在写字楼里上班、在食堂吃饭、在地铁里挤车，展开一系列啼笑皆非的故事。',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    status: '连载中',
    rating: 9.3,
    views: 9800000,
    followers: 2650000,
    tags: ['搞笑', '日常', '神话', '四格'],
    updatedAt: '2026-08-04',
    isHot: false,
    isNew: true,
    isRecommended: true,
    chapters: [
      { id: 'c5-1', title: '第1话 九月的早晨', number: 1, updatedAt: '2026-04-01', pageCount: 12 },
      { id: 'c5-2', title: '第2话 敖烈的烦恼', number: 2, updatedAt: '2026-04-08', pageCount: 14 },
      { id: 'c5-3', title: '第3话 哪吒上学', number: 3, updatedAt: '2026-04-15', pageCount: 12 },
      { id: 'c5-4', title: '第4话 哮天的日常', number: 4, updatedAt: '2026-04-22', pageCount: 14 },
      { id: 'c5-5', title: '第5话 公司团建', number: 5, updatedAt: '2026-04-29', pageCount: 16 },
    ],
  },
  {
    id: '6',
    title: '星海镖师',
    author: '颜开',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20manhua%20cover%20with%20space%20bounty%20hunter%20in%20futuristic%20armor%2C%20neon%20galaxy%20background%2C%20cyberpunk%20aesthetic%2C%20purple%20and%20cyan%20lighting%2C%20dynamic%20action%20pose%20with%20energy%20weapon%2C%20detailed%20mecha%20design&width=400&height=540&seq=comic-xinghai&orientation=portrait',
    description: '在遥远的未来，人类已经进入星际殖民时代。镖师——这个古老而神秘的职业在星海中焕发新生。少年唐小镖怀揣着成为最强镖师的梦想，踏上了星辰大海的冒险之旅。',
    category: '科幻',
    categorySlug: 'kehuan',
    status: '连载中',
    rating: 9.1,
    views: 7200000,
    followers: 1850000,
    tags: ['科幻', '冒险', '机甲', '星际'],
    updatedAt: '2026-07-30',
    isHot: false,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'c6-1', title: '第1话 星际镖师', number: 1, updatedAt: '2026-03-15', pageCount: 40 },
      { id: 'c6-2', title: '第2话 启程', number: 2, updatedAt: '2026-03-22', pageCount: 38 },
      { id: 'c6-3', title: '第3话 第一单', number: 3, updatedAt: '2026-03-29', pageCount: 42 },
      { id: 'c6-4', title: '第4话 星际海盗', number: 4, updatedAt: '2026-04-05', pageCount: 44 },
    ],
  },
  {
    id: '7',
    title: '绝世唐门',
    author: '唐家三少',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manhua%20cover%20with%20young%20master%20using%20hidden%20weapons%20in%20ancient%20Chinese%20academy%20setting%2C%20magical%20martial%20arts%2C%20golden%20and%20emerald%20color%20scheme%2C%20detailed%20costume%20design%2C%20epic%20fantasy%20illustration&width=400&height=540&seq=comic-tangmen&orientation=portrait',
    description: '霍雨浩自幼母亲被父亲的正妻迫害致死，在白虎公爵府中受尽欺凌。在母亲留下的遗物中，他发现了自己身世的秘密，随后进入史莱克学院学习，展开了属于自己的传奇之路。',
    category: '玄幻',
    categorySlug: 'xuanhuan',
    status: '连载中',
    rating: 9.5,
    views: 14500000,
    followers: 3400000,
    tags: ['玄幻', '学院', '热血', '魂师'],
    updatedAt: '2026-08-03',
    isHot: true,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'c7-1', title: '第1话 白虎公爵府', number: 1, updatedAt: '2026-02-10', pageCount: 42 },
      { id: 'c7-2', title: '第2话 天梦冰蚕', number: 2, updatedAt: '2026-02-17', pageCount: 40 },
      { id: 'c7-3', title: '第3话 史莱克学院', number: 3, updatedAt: '2026-02-24', pageCount: 46 },
      { id: 'c7-4', title: '第4话 新生考核', number: 4, updatedAt: '2026-03-03', pageCount: 44 },
      { id: 'c7-5', title: '第5话 魂导器', number: 5, updatedAt: '2026-03-10', pageCount: 48 },
      { id: 'c7-6', title: '第6话 极限单兵', number: 6, updatedAt: '2026-03-17', pageCount: 50 },
    ],
  },
  {
    id: '8',
    title: '全职高手',
    author: '蝴蝶蓝',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20esports%20manhua%20cover%20with%20professional%20gamer%20holding%20mouse%20and%20keyboard%2C%20game%20character%20avatar%20behind%20him%2C%20cyber%20glow%20effects%2C%20cool%20silver%20and%20blue%20tones%2C%20competitive%20gaming%20atmosphere%2C%20detailed%20character%20illustration&width=400&height=540&seq=comic-quanzhi&orientation=portrait',
    description: '网游荣耀中被誉为教科书级别的顶尖高手叶修，因为种种原因遭到俱乐部的驱逐，离开职业圈的他栖身于一家网吧成了一个小小的网管。但是，拥有十年游戏经验的他，在荣耀新开的第十区重新投入了游戏，带着对往昔的回忆和一把未完成的自制武器，开始了重返巅峰之路。',
    category: '热血',
    categorySlug: 'rexue',
    status: '已完结',
    rating: 9.8,
    views: 21000000,
    followers: 4800000,
    tags: ['热血', '电竞', '竞技', '逆袭'],
    updatedAt: '2026-06-15',
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'c8-1', title: '第1话 被驱逐的高手', number: 1, updatedAt: '2026-01-05', pageCount: 40 },
      { id: 'c8-2', title: '第2话 第十区', number: 2, updatedAt: '2026-01-12', pageCount: 38 },
      { id: 'c8-3', title: '第3话 君莫笑', number: 3, updatedAt: '2026-01-19', pageCount: 44 },
      { id: 'c8-4', title: '第4话 千机伞', number: 4, updatedAt: '2026-01-26', pageCount: 42 },
      { id: 'c8-5', title: '第5话 副本纪录', number: 5, updatedAt: '2026-02-02', pageCount: 46 },
      { id: 'c8-6', title: '第6话 蓝溪阁', number: 6, updatedAt: '2026-02-09', pageCount: 40 },
      { id: 'c8-7', title: '第7话 霸气雄图', number: 7, updatedAt: '2026-02-16', pageCount: 44 },
      { id: 'c8-8', title: '第8话 兴欣战队', number: 8, updatedAt: '2026-02-23', pageCount: 48 },
      { id: 'c8-9', title: '第9话 挑战赛', number: 9, updatedAt: '2026-03-02', pageCount: 50 },
      { id: 'c8-10', title: '第10话 重返巅峰', number: 10, updatedAt: '2026-03-09', pageCount: 52 },
    ],
  },
  {
    id: '9',
    title: '灵笼',
    author: '艺画开天',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20post-apocalyptic%20manhua%20cover%20with%20soldiers%20in%20powered%20exoskeleton%20fighting%20monsters%20in%20ruined%20city%2C%20dark%20atmospheric%20lighting%2C%20survival%20horror%20theme%2C%20orange%20and%20dark%20gray%20tones%2C%20cinematic%20composition&width=400&height=540&seq=comic-linglong&orientation=portrait',
    description: '未来，一场史无前例的地质灾害摧毁了人类文明。地球生物圈发生了根本性变化，人类面临着生存的严峻考验。幸存的人类避难于一座悬浮在空中的堡垒——"灯塔"之上，为了生存，他们不得不与地面上的怪物展开殊死搏斗。',
    category: '科幻',
    categorySlug: 'kehuan',
    status: '连载中',
    rating: 9.6,
    views: 13500000,
    followers: 3200000,
    tags: ['科幻', '末日', '机甲', '生存'],
    updatedAt: '2026-08-02',
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'c9-1', title: '第1话 灯塔', number: 1, updatedAt: '2026-02-20', pageCount: 48 },
      { id: 'c9-2', title: '第2话 猎荒者', number: 2, updatedAt: '2026-02-27', pageCount: 50 },
      { id: 'c9-3', title: '第3话 地面任务', number: 3, updatedAt: '2026-03-06', pageCount: 46 },
      { id: 'c9-4', title: '第4话 噬极兽', number: 4, updatedAt: '2026-03-13', pageCount: 52 },
      { id: 'c9-5', title: '第5话 脊蛊', number: 5, updatedAt: '2026-03-20', pageCount: 44 },
      { id: 'c9-6', title: '第6话 玛娜生态', number: 6, updatedAt: '2026-03-27', pageCount: 48 },
    ],
  },
  {
    id: '10',
    title: '师兄啊师兄',
    author: '青衫取醉',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20manhua%20cover%20with%20handsome%20Taoist%20disciple%20in%20white%20robes%20meditating%20on%20clouds%2C%20celestial%20palace%20in%20background%2C%20ethereal%20atmosphere%2C%20soft%20golden%20and%20white%20tones%2C%20elegant%20ink%20painting%20style%20illustration&width=400&height=540&seq=comic-shixiong&orientation=portrait',
    description: '现代青年李长寿穿越到修仙世界，成为一个小小的外门弟子。凭借前世的人生经验和谨慎小心的性格，他在危机四伏的修仙界中步步为营，低调发育。别人修仙我苟道，稳住别浪，我们就能赢！',
    category: '玄幻',
    categorySlug: 'xuanhuan',
    status: '连载中',
    rating: 9.2,
    views: 8600000,
    followers: 2200000,
    tags: ['玄幻', '修仙', '穿越', '搞笑'],
    updatedAt: '2026-08-04',
    isHot: false,
    isNew: true,
    isRecommended: false,
    chapters: [
      { id: 'c10-1', title: '第1话 穿越修仙界', number: 1, updatedAt: '2026-05-01', pageCount: 38 },
      { id: 'c10-2', title: '第2话 外门弟子', number: 2, updatedAt: '2026-05-08', pageCount: 40 },
      { id: 'c10-3', title: '第3话 苟道法则', number: 3, updatedAt: '2026-05-15', pageCount: 36 },
      { id: 'c10-4', title: '第4话 小师叔', number: 4, updatedAt: '2026-05-22', pageCount: 42 },
    ],
  },
  {
    id: '11',
    title: '百炼成神',
    author: '恩赐解脱',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manhua%20cover%20with%20warrior%20forging%20a%20divine%20weapon%20in%20volcanic%20forge%2C%20flames%20and%20sparks%20flying%2C%20intense%20red%20and%20orange%20color%20scheme%2C%20muscular%20character%20design%2C%20dynamic%20action%20illustration&width=400&height=540&seq=comic-bailian&orientation=portrait',
    description: '罗征，一个卑微的家族旁系弟子，因天生异禀被家族视为怪物而受到排挤。但他凭借顽强的意志和不断的修炼，一步步从最底层崛起，锤炼自身，百炼成神，最终站在了世界的巅峰。',
    category: '玄幻',
    categorySlug: 'xuanhuan',
    status: '连载中',
    rating: 9.0,
    views: 6800000,
    followers: 1750000,
    tags: ['玄幻', '热血', '修炼', '逆袭'],
    updatedAt: '2026-07-29',
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'c11-1', title: '第1话 卑微的旁系', number: 1, updatedAt: '2026-04-10', pageCount: 40 },
      { id: 'c11-2', title: '第2话 炼器之法', number: 2, updatedAt: '2026-04-17', pageCount: 38 },
      { id: 'c11-3', title: '第3话 试炼之地', number: 3, updatedAt: '2026-04-24', pageCount: 44 },
    ],
  },
  {
    id: '12',
    title: '大王饶命',
    author: '会说话的肘子',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20manhua%20cover%20with%20smirking%20teenager%20surrounded%20by%20supernatural%20energy%20in%20modern%20school%20setting%2C%20humorous%20expression%2C%20bright%20and%20vibrant%20colors%2C%20playful%20illustration%20style%2C%20anime-inspired%20design&width=400&height=540&seq=comic-dawang&orientation=portrait',
    description: '灵气复苏，万物进化。吕树，一个靠卖煮鸡蛋为生的孤儿，意外觉醒了异能——他能看到别人身上的负面情绪值，并以此兑换各种神奇能力。从此，他走上了一条靠气人变强的独特修炼之路。',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    status: '连载中',
    rating: 9.4,
    views: 10200000,
    followers: 2750000,
    tags: ['搞笑', '异能', '都市', '校园'],
    updatedAt: '2026-08-03',
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'c12-1', title: '第1话 卖鸡蛋的少年', number: 1, updatedAt: '2026-03-20', pageCount: 36 },
      { id: 'c12-2', title: '第2话 负面情绪值', number: 2, updatedAt: '2026-03-27', pageCount: 38 },
      { id: 'c12-3', title: '第3话 气人大法', number: 3, updatedAt: '2026-04-03', pageCount: 40 },
      { id: 'c12-4', title: '第4话 觉醒者', number: 4, updatedAt: '2026-04-10', pageCount: 42 },
      { id: 'c12-5', title: '第5话 道元班', number: 5, updatedAt: '2026-04-17', pageCount: 38 },
    ],
  },
  {
    id: '13',
    title: '武动乾坤',
    author: '天蚕土豆',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20manhua%20cover%20with%20young%20warrior%20surrounded%20by%20swirling%20spiritual%20energy%20in%20ancient%20forest%2C%20martial%20arts%20theme%2C%20earthy%20green%20and%20gold%20tones%2C%20powerful%20aura%20visualization%2C%20detailed%20fantasy%20illustration&width=400&height=540&seq=comic-wudong&orientation=portrait',
    description: '大炎王朝天都郡炎城青阳镇，一个落魄的林氏子弟——林动，在山洞间偶然捡到一块神秘的石符。从此他的命运开始改变，一步一步走向武道巅峰。',
    category: '玄幻',
    categorySlug: 'xuanhuan',
    status: '已完结',
    rating: 9.3,
    views: 11800000,
    followers: 2900000,
    tags: ['玄幻', '热血', '修炼', '逆袭'],
    updatedAt: '2026-05-20',
    isHot: false,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'c13-1', title: '第1话 青阳镇', number: 1, updatedAt: '2026-01-08', pageCount: 40 },
      { id: 'c13-2', title: '第2话 神秘石符', number: 2, updatedAt: '2026-01-15', pageCount: 42 },
      { id: 'c13-3', title: '第3话 青檀', number: 3, updatedAt: '2026-01-22', pageCount: 38 },
      { id: 'c13-4', title: '第4话 族比', number: 4, updatedAt: '2026-01-29', pageCount: 44 },
      { id: 'c13-5', title: '第5话 炎城', number: 5, updatedAt: '2026-02-05', pageCount: 46 },
      { id: 'c13-6', title: '第6话 大荒郡', number: 6, updatedAt: '2026-02-12', pageCount: 42 },
      { id: 'c13-7', title: '第7话 百朝大战', number: 7, updatedAt: '2026-02-19', pageCount: 50 },
      { id: 'c13-8', title: '第8话 超级宗派', number: 8, updatedAt: '2026-02-26', pageCount: 48 },
    ],
  },
  {
    id: '14',
    title: '仙王的日常生活',
    author: '枯玄',
    cover: 'https://readdy.ai/api/search-image?query=Funny%20Chinese%20school%20life%20manhua%20cover%20with%20overpowered%20student%20trying%20to%20live%20normally%20in%20cultivation%20high%20school%2C%20contrast%20between%20mundane%20and%20divine%2C%20colorful%20comedic%20style%2C%20bright%20anime-inspired%20illustration&width=400&height=540&seq=comic-xianwang&orientation=portrait',
    description: '王令，一个拥有毁天灭地力量的修真奇才，却一心只想做个普通的中学二年级学生。然而事与愿违，各路神仙妖怪总是找上门来，打破他平静的校园生活。且看仙王如何在日常与非日常之间反复横跳！',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    status: '连载中',
    rating: 9.1,
    views: 7800000,
    followers: 1950000,
    tags: ['搞笑', '校园', '修仙', '日常'],
    updatedAt: '2026-08-01',
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: 'c14-1', title: '第1话 普通的初二学生', number: 1, updatedAt: '2026-04-05', pageCount: 32 },
      { id: 'c14-2', title: '第2话 新来的转校生', number: 2, updatedAt: '2026-04-12', pageCount: 34 },
      { id: 'c14-3', title: '第3话 灵力测试', number: 3, updatedAt: '2026-04-19', pageCount: 36 },
      { id: 'c14-4', title: '第4话 修学旅行', number: 4, updatedAt: '2026-04-26', pageCount: 38 },
    ],
  },
  {
    id: '15',
    title: '镖人',
    author: '许先哲',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20action%20manhua%20cover%20with%20lone%20swordsman%20in%20the%20desert%20during%20Tang%20dynasty%2C%20gritty%20realistic%20art%20style%2C%20sandstorm%20atmosphere%2C%20warm%20sepia%20tones%2C%20ink%20wash%20painting%20aesthetic%2C%20cinematic%20composition&width=400&height=540&seq=comic-biaoren&orientation=portrait',
    description: '大业三年（公元607年），隋王朝在隋炀帝杨广的残暴统治下民不聊生。身手不凡的镖客刀马行走于西域大漠，他接下了一单特殊的护送任务，却因此被卷入了一场牵动天下命运的纷争之中。',
    category: '武侠',
    categorySlug: 'wuxia',
    status: '连载中',
    rating: 9.7,
    views: 16500000,
    followers: 3900000,
    tags: ['武侠', '历史', '热血', '硬核'],
    updatedAt: '2026-08-02',
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: 'c15-1', title: '第1话 西域刀马', number: 1, updatedAt: '2026-02-01', pageCount: 50 },
      { id: 'c15-2', title: '第2话 知世郎', number: 2, updatedAt: '2026-02-08', pageCount: 48 },
      { id: 'c15-3', title: '第3话 大漠追杀', number: 3, updatedAt: '2026-02-15', pageCount: 52 },
      { id: 'c15-4', title: '第4话 老莫', number: 4, updatedAt: '2026-02-22', pageCount: 46 },
      { id: 'c15-5', title: '第5话 阿育娅', number: 5, updatedAt: '2026-03-01', pageCount: 50 },
      { id: 'c15-6', title: '第6话 竖的誓言', number: 6, updatedAt: '2026-03-08', pageCount: 48 },
    ],
  },
  {
    id: '16',
    title: '万古神帝',
    author: '飞天鱼',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20epic%20fantasy%20manhua%20cover%20with%20reincarnated%20god%20emperor%20in%20ancient%20palace%2C%20divine%20light%20radiating%2C%20celestial%20beings%20in%20background%2C%20golden%20and%20white%20divine%20color%20scheme%2C%20majestic%20atmosphere%2C%20detailed%20character%20design&width=400&height=540&seq=comic-wangu&orientation=portrait',
    description: '八百年前，明帝之子张若尘，被他的未婚妻池瑶公主杀死，一代天骄就此陨落。八百年后，张若尘重新活了过来，却发现曾经杀死他的未婚妻已经统一昆仑界，成为第一女皇。他要做的，就是重新修炼，夺回属于自己的一切。',
    category: '玄幻',
    categorySlug: 'xuanhuan',
    status: '连载中',
    rating: 9.2,
    views: 10500000,
    followers: 2600000,
    tags: ['玄幻', '重生', '热血', '逆袭'],
    updatedAt: '2026-08-04',
    isHot: false,
    isNew: true,
    isRecommended: false,
    chapters: [
      { id: 'c16-1', title: '第1话 八百年后', number: 1, updatedAt: '2026-05-10', pageCount: 42 },
      { id: 'c16-2', title: '第2话 时空秘典', number: 2, updatedAt: '2026-05-17', pageCount: 40 },
      { id: 'c16-3', title: '第3话 武市学宫', number: 3, updatedAt: '2026-05-24', pageCount: 44 },
    ],
  },
];

export function getComicById(id: string): ComicData | undefined {
  return comics.find((c) => c.id === id);
}

export function getComicsByCategory(slug: string): ComicData[] {
  if (slug === 'all') return comics;
  return comics.filter((c) => c.categorySlug === slug);
}

export function getHotComics(): ComicData[] {
  return comics.filter((c) => c.isHot);
}

export function getNewComics(): ComicData[] {
  return comics.filter((c) => c.isNew);
}

export function getRecommendedComics(): ComicData[] {
  return comics.filter((c) => c.isRecommended);
}